/**
 * ReservationKindField.tsx
 * 予約種別（通常 / その他 / 米軍）のラジオボタン。
 * 値は json_data.data['予約種別']（lib/reservationKind.ts）。保存はパネル本体の保存ボタン
 * （onChange で下書きの json_data を差し替えるだけ。ホテル送迎・JsonDataModal と同じ経路）。
 */
import React from 'react';
import { FieldMarkWrap } from '../conflict/fieldState';
import {
  RESERVATION_KINDS,
  ReservationKind,
  getReservationKind,
  applyReservationKind,
} from '../../../lib/reservationKind';

const JSON_FIELDS = ['json_data'] as const;

interface Props {
  jsonData: unknown;
  onChange?: (patch: { json_data: unknown }) => void;
  disabled?: boolean;
}

/** 米軍は運用が通常と違う（車両・料金・報告の対象外など）ので、選択中は色で目立たせる */
const KIND_COLOR: Record<ReservationKind, string | null> = {
  通常: null,
  その他: '#64748b',
  米軍: '#166534',
};

export default function ReservationKindField({ jsonData, onChange, disabled }: Props) {
  const current = getReservationKind(jsonData);
  const canEdit = !disabled && !!onChange;

  return (
    <FieldMarkWrap fields={JSON_FIELDS} chip>
      <div className="gc-field" data-testid="reservation-kind">
        <label className="gc-label" style={{ fontSize: '0.85rem', color: '#64748b' }}>
          予約種別
        </label>
        <div role="radiogroup" aria-label="予約種別" style={{ display: 'flex', gap: 16, padding: '4px 0' }}>
          {RESERVATION_KINDS.map((kind) => {
            const checked = kind === current;
            const color = checked ? KIND_COLOR[kind] : null;
            return (
              <label
                key={kind}
                style={{
                  display: 'flex', alignItems: 'center', gap: 4,
                  cursor: canEdit ? 'pointer' : 'default',
                  fontSize: '0.85rem',
                  fontWeight: color ? 700 : 400,
                  color: color || undefined,
                }}
              >
                <input
                  type="radio"
                  name="reservation-kind"
                  value={kind}
                  checked={checked}
                  disabled={!canEdit}
                  onChange={() => onChange?.({ json_data: applyReservationKind(jsonData, kind) })}
                  style={{ width: 16, height: 16, margin: 0 }}
                />
                {kind}
              </label>
            );
          })}
        </div>
      </div>
    </FieldMarkWrap>
  );
}
